import { Injectable } from '@angular/core';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import { Filter } from '@models/types/app/Filter.type';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  // FILTERS
  public readonly filter: Filter = {
    section: [],
    row:     [],
    seat:    []
  }

  public get hasFilters(): boolean {
    return Object.values(this.filter).some((value: string[]) => value.length > 0);
  }

  // METHODS
  public getFilterByKey(key: keyof Filter): string[] {
    return this.filter[key] || [];
  }

  public getFiltersByView(view: AppViews): string[] {
    
    switch(view) {

      case AppViews.Topview:
        return this.filter.section;
      
      case AppViews.Seatmap:
        return [this.filter.row, this.filter.seat].flat();
      
      case AppViews.Main:
        return [this.filter.section, this.filter.row, this.filter.seat].flat();
      
      default:
        return [];
    
    }

  }

  public setFilters(view: keyof Filter, availability: string[]): void {
    this.filter[view] = availability;
  }

  public clearFilters(): void {
       
    for (const key of Object.keys(this.filter) as (keyof Filter)[]) this.filter[key] = [];
  
  }

}
